import {
  GET_CITY_LIST_BY_REGION_ID,
  SEARCH_CITY
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE,
  END
} from '../../utils/status';
import * as cityService from '../../services/city';
import {select as selectCityList} from '../reducers/city/cityList';
import {select as selectSearch} from '../reducers/city/search';

// 已被取消的 Promise 对象
let invalidPromise = Promise.resolve(true);
invalidPromise.cancel();

export function search(search_word, page = 1) {
  return function (dispatch, getState) {
    let state = getState();
    let status = selectSearch(state, 'status');

    // 正在加载更多，或已经没有了，就不要挤了
    if (page !== 1) {
      if (status === END || status === PENDING) {
        return invalidPromise;
      }
    }

    // 请求第一页，取消上一次请求
    if (search.promise) {
      search.promise.cancel();
      search.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }

    dispatch({
      type: SEARCH_CITY,
      status: PENDING
    });

    search.promise = cityService.search(search_word, page)
      .then(function (data) {
        let status = data.pager.page >= data.pager.total_page ? END : SUCCESS;
        dispatch({
          type: SEARCH_CITY,
          status: status,
          pager: data.pager,
          data: data.list
        });

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: SEARCH_CITY,
          status: FAILURE,
          data: err
        });

        throw err;
      });

    return search.promise;
  };
}


export function getListByRegionId(region_id, page = 1) {
  return function (dispatch, getState) {
    let state = getState();
    let status = selectCityList(state, 'status');

    // 正在加载更多，或已经没有了，就不要挤了
    if (page !== 1) {
      if (status === END || status === PENDING) {
        return invalidPromise;
      }
    }

    // 取消上一次请求
    if (getListByRegionId.promise) {
      getListByRegionId.promise.cancel();
      getListByRegionId.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }

    dispatch({
      type: GET_CITY_LIST_BY_REGION_ID,
      status: PENDING
    });

    getListByRegionId.promise = cityService.getListByRegionId(region_id, page)
      .then(function (data) {
        let status = data.pager.page >= data.pager.total_page ? END : SUCCESS;
        dispatch({
          type: GET_CITY_LIST_BY_REGION_ID,
          status: status,
          pager: data.pager,
          data: data.list
        });

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_CITY_LIST_BY_REGION_ID,
          status: FAILURE,
          data: err
        });

        throw err;
      });

    return getListByRegionId.promise;
  };
}





// WEBPACK FOOTER //
// ./src/store/actions/city.js